export interface SupportFormData {
  name: string;
  email: string;
  bin: string;
  last4: string;
  paymentDate: string;
  transactionAmount: string;
  applicationTopic: ApplicationTopic;
  message: string;
  file?: File | null;
}

export type ApplicationTopic = '' | 'Support' | 'Billing' | 'Legal' | 'Other';

export interface FormErrors {
  name?: string;
  email?: string;
  bin?: string;
  last4?: string;
  paymentDate?: string;
  transactionAmount?: string;
  applicationTopic?: string;
  message?: string;
  file?: string;
}

export interface FormTouched {
  name: boolean;
  email: boolean;
  bin: boolean;
  last4: boolean;
  paymentDate: boolean;
  transactionAmount: boolean;
  applicationTopic: boolean;
  message: boolean;
  file: boolean;
}

export interface FormState {
  data: SupportFormData;
  errors: FormErrors;
  touched: FormTouched;
  isValid: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
}

export const INITIAL_FORM_DATA: SupportFormData = {
  name: '',
  email: '',
  bin: '',
  last4: '',
  paymentDate: '',
  transactionAmount: '',
  applicationTopic: '',
  message: '',
  file: null
};

export const INITIAL_FORM_TOUCHED: FormTouched = {
  name: false,
  email: false,
  bin: false,
  last4: false,
  paymentDate: false,
  transactionAmount: false,
  applicationTopic: false,
  message: false,
  file: false
};

export const APPLICATION_TOPICS: ApplicationTopic[] = ['Support', 'Billing', 'Legal', 'Other'];

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
